'use strict';

import { get } from '@/helpers/api';

export default {
    getMenu({ commit, rootState }) {
        rootState.user.selectedCustomer
            ? get('Archive', `GetMenuItemsByCustomerId?id=${rootState.user.selectedCustomer.id}${(rootState.user.selectedBuilding ? '&buildingId=' + rootState.user.selectedBuilding : '')}`)
                .then((response) => commit('SET_MENU', response.data))
            : commit('SET_MENU', []);
    },
    getGlobalDocsMenu({ commit }) {
        return get('Archive', 'GetAllByGlobalDocsCustomer')
            .then((response) => {
                commit('SET_GLOBAL_DOCS', response.data);
            })
            .catch((err) => {
                commit('SET_GLOBAL_DOCS', []);
            });
    }
};
